"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _style = _interopRequireDefault(require("./style.css"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Faq = exports["default"] = /*#__PURE__*/function (_React$Component) {
  _inherits(Faq, _React$Component);
  function Faq(props) {
    var _this;
    _classCallCheck(this, Faq);
    _this = _callSuper(this, Faq, [props]);
    _defineProperty(_assertThisInitialized(_this), "state", {
      hideOverflow: true
    });
    _defineProperty(_assertThisInitialized(_this), "toggleMore", function () {
      _this.setState({
        hideOverflow: !_this.state.hideOverflow
      });
    });
    _this.toggleMore = _this.toggleMore.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(Faq, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        questions = _this$props.questions,
        limit = _this$props.limit,
        headerText = _this$props.headerText,
        showMoreText = _this$props.showMoreText,
        showFewerText = _this$props.showFewerText;
      var hideOverflow = this.state.hideOverflow;
      var qCount = questions.length;
      var main = [];
      var overflow = [];
      var item = '';
      if (qCount < 1) {
        return /*#__PURE__*/_react["default"].createElement("div", null);
      }
      for (var i = 0; i < qCount; i++) {
        item = /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].item,
          key: i
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].question
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: _style["default"].q
        }, "Q."), /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
          content: questions[i].question
        })), /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].answer
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: _style["default"].a
        }, "A."), /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
          content: questions[i].answer
        })), /*#__PURE__*/_react["default"].createElement("hr", null));
        if (limit > 0 && i < limit) {
          main.push(item);
        } else {
          overflow.push(item);
        }
      }
      if (overflow.length === 0) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].faq
        }, /*#__PURE__*/_react["default"].createElement("h4", null, headerText), main);
      }
      if (hideOverflow) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].faq
        }, /*#__PURE__*/_react["default"].createElement("h4", null, headerText), main, /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].controls
        }, /*#__PURE__*/_react["default"].createElement("a", {
          onClick: this.toggleMore
        }, showMoreText)));
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].faq
      }, /*#__PURE__*/_react["default"].createElement("h4", null, headerText), main, overflow, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].controls
      }, /*#__PURE__*/_react["default"].createElement("a", {
        onClick: this.toggleMore
      }, showFewerText)));
    }
  }]);
  return Faq;
}(_react["default"].Component);
_defineProperty(Faq, "propTypes", {
  headerText: _propTypes["default"].string,
  showMoreText: _propTypes["default"].string,
  showFewerText: _propTypes["default"].string,
  questions: _propTypes["default"].array,
  limit: _propTypes["default"].number
});
_defineProperty(Faq, "defaultProps", {
  headerText: 'Frequently Asked Questions',
  showMoreText: 'Show more questions & answers...',
  showFewerText: 'Show fewer questions & answers...',
  questions: [],
  limit: 999999999
});